import React from 'react'
import ReactGA from 'react-ga';
import { Card } from 'primereact/card'
import { connect } from "react-redux";
import * as candidateActionCreators from "../actionCreators/candidate";
import * as appActionCreators from "../actionCreators/app";
import * as lookupCodeActionCreators from "../actionCreators/lookupCode";
import * as systemParameterActionCreators from "../actionCreators/systemParameter";
import '../css/contactus.css'


class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasLoaded: false
         };
    }

    componentDidMount() {
      document.title = "Contact Us - BoardingCall - South Australian Government Boards and Committees";
    // is invoked immediately after a component is mounted. 
    // Initialization that requires DOM nodes should go here. If you need to load data from a remote endpoint, this is a good place to instantiate the network request.   
    this.props
      .setLoading(true)
      .then(() => this.props.getContactUsPageHtmlText())
      .then(() => this.props.setLoading(false))
      .catch(error => {
        this.props.handleError(error).then(() => this.props.setLoading(false));
      });
      this.initializeReactGA();
  }
   initializeReactGA() {
    ReactGA.initialize(this.props.systemParameter.googleAnalyticsTrackingCode);
    ReactGA.pageview(window.location.pathname + window.location.hash);
 }

    render() { 
         let contactUsPageHtmlText = this.props.systemParameter.contactUsPageHtmlText?this.props.systemParameter.contactUsPageHtmlText:''
        return (  
          <div className="contactUsPage">
                <Card title="">
                    <div className="p-col-12">
                       <p
                        dangerouslySetInnerHTML={{
                            __html: contactUsPageHtmlText
                        }}
                        />
                  </div>
                </Card>
          </div>
        );
    }
}
 
 const mapStateToProps = state => {
  let { candidate, auth, lookupCode, systemParameter } = state;
  return { candidate, auth, lookupCode, systemParameter };
};

 // this is how to combine actions available
const actionCreators = {
  ...candidateActionCreators,
  ...appActionCreators,
  ...lookupCodeActionCreators,
  ...systemParameterActionCreators
};

export default connect(
  mapStateToProps,
  actionCreators
)(ContactUs);



// WEBPACK FOOTER //
// ./src/container/ContactUs.js